import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { IconMenu2, IconX } from "@tabler/icons-react";

import logo from "../../../../assets/Aara_logo.png";
import { useQuiz } from "../../../../context/QuizContext";
import "./psychometric.css";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const { responses } = useQuiz();
  const navigate = useNavigate();
  const location = useLocation();
  const isSubmitForm = location.pathname === "/submit"; // Check if user is on submitform route

  return (
    <nav className="psych-navbar">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-3">
          <img src={logo} alt="logo" className="nav-logo" />
        </div>
        <div className="hidden md:flex items-center gap-1">
          <Link
            to="/psychometric"
            className={`nav-link ${
              isSubmitForm ? "pointer-events-none opacity-40" : ""
            }`}
          >
            Home
          </Link>
          {responses.length >= 19 || responses.length === 0 ? (
            <a
              href="https://aaraconsultancy.com/about-us/"
              target="_blank"
              rel="noopener noreferrer"
              className={`nav-link ${
                isSubmitForm ? "pointer-events-none opacity-40" : ""
              }`}
            >
              About Us
            </a>
          ) : (
            <Link
              className={`nav-link ${
                isSubmitForm ? "pointer-events-none opacity-40" : ""
              }`}
            >
              About Us
            </Link>
          )}
          {responses.length >= 19 || responses.length === 0 ? (
            <a
              href="https://aaraconsultancy.com/contact-us/"
              target="_blank"
              rel="noopener noreferrer"
              className={`nav-link ${
                isSubmitForm ? "pointer-events-none opacity-40" : ""
              }`}
            >
              Contact Us
            </a>
          ) : (
            <Link
              className={`nav-link ${
                isSubmitForm ? "pointer-events-none opacity-40" : ""
              }`}
            >
              Contact Us
            </Link>
          )}
        </div>

        {/* Mobile menu button */}
        <div className="md:hidden flex items-center">
          <button onClick={() => setIsOpen(!isOpen)} className="text-white p-1">
            {isOpen ? <IconX stroke={2} /> : <IconMenu2 stroke={2} />}
          </button>
        </div>
      </div>
      {/* Drawer menu for mobile */}
      <div
        className={`fixed top-0 right-0 h-full w-64 transform ${
          isOpen ? "translate-x-0" : "translate-x-full"
        } transition-transform duration-300 ease-in-out md:hidden`}
        style={{ backgroundColor: "#1a1145", borderLeft: "1px solid rgba(255,255,255,0.1)", zIndex: 9999 }}
      >
        <div className="flex justify-end p-4">
          <button onClick={() => setIsOpen(false)}>
            <IconX stroke={2} className="w-8 h-8 text-white" />
          </button>
        </div>
        <div className="flex flex-col space-y-4 px-10 py-4">
          <Link
            to="/psychometric"
            className={`nav-link ${
              isSubmitForm ? "pointer-events-none opacity-40" : ""
            }`}
            onClick={() => setIsOpen(false)}
          >
            Home
          </Link>
          {responses.length >= 19 || responses.length === 0 ? (
            <a
              href="https://aaraconsultancy.com/about-us/"
              target="_blank"
              rel="noopener noreferrer"
              className={`nav-link ${
                isSubmitForm ? "pointer-events-none opacity-40" : ""
              }`}
            >
              About Us
            </a>
          ) : (
            <Link
              className={`nav-link ${
                isSubmitForm ? "pointer-events-none opacity-40" : ""
              }`}
            >
              About Us
            </Link>
          )}
          {responses.length >= 19 || responses.length === 0 ? (
            <a
              href="https://aaraconsultancy.com/contact-us/"
              target="_blank"
              rel="noopener noreferrer"
              className={`nav-link ${
                isSubmitForm ? "pointer-events-none opacity-40" : ""
              }`}
            >
              Contact Us
            </a>
          ) : (
            <Link
              className={`nav-link ${
                isSubmitForm ? "pointer-events-none opacity-40" : ""
              }`}
            >
              Contact Us
            </Link>
          )}
        </div>
      </div>

      {/* Overlay to close the drawer */}
      {isOpen && (
        <div
          className="fixed inset-0"
          style={{ backgroundColor: "rgba(0,0,0,0.6)", zIndex: 9998 }}
          onClick={() => setIsOpen(false)}
        ></div>
      )}
    </nav>
  );
}

export default Navbar;
